import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";

import Button from "@mui/material/Button";

export default function PendingRequests(props) {
  const [pendingVaults, setPendingVaults] = useState([]);

  const getVotes = () => {
    const apiUrl = "/votes";
    Axios.get(
      process.env.REACT_APP_CRUD_SRV + apiUrl // +
      // "?auth=" +
      // userAuthWallet +
      // "&cs=" +
      // sha256(apiUrl + userAuthWallet + process.env.REACT_APP_SECRET)
    ).then((res) => {
      if (res.data?.status == 200) setPendingVaults(res.data.response);
    });
  };

  useEffect(() => {
    // if (userAuthWallet != "") {
    getVotes();
    // }
  }, []);

  return (
    <div>
      <h2>
        Pending Requests
        {/* <label className="vaultBadge vaultUnkn">Unknown</label> */}
      </h2>
      <p>
        Here are the pending requests to make Manual vaults to Auto vaults. When
        the number of votes becomes equal to the requested number, this request
        will be processed by our team.
      </p>
      <p>
        To make a new request not listed in the list bellow, you have to click
        above button "Add Manual vault", and then click "Ask to make it Auto
        vault" button near added vault.
      </p>

      <ul>
        {pendingVaults.map((vault) => {
          return (
            <li key={vault.vaultId}>
              {vault.blockchain} &gt; {vault.platform} &gt; {vault.assetId}.{" "}
              {vault.vault} ({vault.uses}) *** {vault.votes}/30{" "}
              {props.userAuthWallet && (
                <Button
                  variant="outlined"
                  className="extraSmall"
                  // startIcon={<LocalAtmOutlinedIcon />}
                  data-row={JSON.stringify({
                    id: vault.assetId,
                    vault: vault.vault,
                  })}
                  onClick={props.handleClickOpen}
                >
                  Vote to make it <label className="vaultBadge">Auto</label>{" "}
                  Vault
                </Button>
              )}
            </li>
          );
        })}
        {/* <li>
          MOR-BUSD @ FTM *** <a href="">http://growthdefi/mor-busd.html</a> ***
          21/30
          <Button
            variant="outlined"
            className="extraSmall"
            // startIcon={<LocalAtmOutlinedIcon />}
          >
            Vote +1
          </Button>
          <Button
            variant="outlined"
            className="extraSmall"
            // startIcon={<LocalAtmOutlinedIcon />}
          >
            +9
          </Button>
        </li>
        <li>
          MOR-BUSD @ Moonriver ***{" "}
          <a href="">http://growthdefi/mor-busd.html</a> *** 7/30
          <Button
            variant="outlined"
            className="extraSmall"
            // startIcon={<LocalAtmOutlinedIcon />}
          >
            Vote +1
          </Button>
          <Button
            variant="outlined"
            className="extraSmall"
            // startIcon={<LocalAtmOutlinedIcon />}
          >
            +23
          </Button>
        </li> */}
      </ul>
    </div>
  );
}
